import { InjectionToken } from "@angular/core";

import { WidgetHub } from "../models/widget-hub.interface";
import { WidgetResolver } from "../models/widget-resolver.interface";


export const WIDGET_HUB = new InjectionToken<WidgetHub>("WIDGET_HUB");

export const WIDGET_RESOLVER = new InjectionToken<WidgetResolver>("WIDGET_RESOLVER");
